export const LIVE_UPDATE_DISCHARGE_SUBMIT_MESSAGE =
  "Submit live updates before submitting discharge.";

export const ENHANCEMENT_QUERY_DISCHARGE_SUBMIT_MESSAGE =
  "Please reply to the open enhancement query before submitting discharge.";

export const ENHANCEMENT_PENDING_DISCHARGE_SUBMIT_MESSAGE =
  "Please wait until the latest enhancement is approved before submitting discharge.";

const GENERIC_AXIOS_STATUS_MESSAGE = /^Request failed with status code \d+$/;

export const normalizeDischargeSubmitErrorMessage = (
  message: string,
): string => {
  const normalized = String(message || "").trim();
  if (!normalized) {
    return LIVE_UPDATE_DISCHARGE_SUBMIT_MESSAGE;
  }
  const lower = normalized.toLowerCase();
  if (
    lower.includes("enhancement query") ||
    (lower.includes("enhancement") && lower.includes("reply"))
  ) {
    return ENHANCEMENT_QUERY_DISCHARGE_SUBMIT_MESSAGE;
  }
  if (
    (lower.includes("enhancement") &&
      (lower.includes("pending") ||
        lower.includes("awaiting") ||
        lower.includes("approved") ||
        lower.includes("rejected") ||
        lower.includes("complete"))) ||
    lower.includes("enhancementclaimgate")
  ) {
    return ENHANCEMENT_PENDING_DISCHARGE_SUBMIT_MESSAGE;
  }
  if (
    lower.includes("live update") ||
    lower.includes("complete all live updates")
  ) {
    return LIVE_UPDATE_DISCHARGE_SUBMIT_MESSAGE;
  }
  return normalized;
};

/** Extract user-facing text from BPA/axios errors (plain string or JSON body). */
export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const maybeError = error as {
    response?: { data?: unknown };
    message?: string;
  };
  const data = maybeError?.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (data && typeof data === "object") {
    const record = data as Record<string, unknown>;
    // Prefer concrete backend reason fields over generic HTTP titles like "Conflict".
    for (const key of ["message", "detail", "reason"] as const) {
      const value = record[key];
      if (typeof value === "string" && value.trim()) {
        return value.trim();
      }
    }
    for (const key of ["error", "title"] as const) {
      const value = record[key];
      if (
        typeof value === "string" &&
        value.trim() &&
        !/^(conflict|bad request|forbidden|unauthorized|not found)$/i.test(
          value.trim(),
        )
      ) {
        return value.trim();
      }
    }
  }

  const errorMessage = maybeError?.message?.trim();
  if (
    errorMessage &&
    !GENERIC_AXIOS_STATUS_MESSAGE.test(errorMessage) &&
    errorMessage !== "Network Error"
  ) {
    return errorMessage;
  }

  return fallback;
};

export const getDischargeSubmitErrorMessage = (
  error: unknown,
  fallback = "Unable to submit discharge",
): string =>
  normalizeDischargeSubmitErrorMessage(
    getApiErrorMessage(error, fallback),
  );
